function isMaxDate(date: string) {
    const maxDate = new Date('9999-12-31T23:59:59.999Z');
    return new Date(date).getDate() === maxDate.getDate();
}

export default isMaxDate;
